import React from "react"
// import Search from '../services/Search'

class Page extends React.Component {
  constructor(props) {
    super(props)

    this.handleInputClicked = this.handleInputClicked.bind(this)
    this.handleInputChanged = this.handleInputChanged.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleInputClicked(){
    let model = this.props.model
    let filters = model.filters
    filters.departments.on = !filters.departments.on
    filters.sort_by.on = false
    filters.details.on = false
    filters.orgs.on = false
    filters.themes.on = false
    if(!filters.departments.on){
      model.filters.departments.query = ""
    }
    this.props.changeState(model)
  }

  handleInputChanged(event){
    let v = event.currentTarget.value.trim()
    let model = this.props.model
    model.filters.departments.query = v
    if(!_.isEmpty(v)){
      model.filters.departments.on = true
    }
    this.props.changeState(model)
  }

  handleSelect({event, item}){
    let model = this.props.model
    let selected = model.filters.departments.selected
    selected[item] = !selected[item]
    model.filters.pagination.page = 1
    this.props.changeState(model)
    this.props.search({})
  }

  render(){
    const self = this
    let list = []
    const model = self.props.model
    const filters = model.filters
    const results = model.results.results

    if(results){
      let groups = results.groups
      if(groups){
        let departments = groups.categories
        if(departments){
          for(let name in departments){
            if(name.toLowerCase().includes(filters.departments.query.toLowerCase())){
              const count = departments[name]
              let itemHtml = (
                  <div key={name} className="ic-item grid-x grid-padding-x" onClick={(e)=>{self.handleSelect({event: e, item: name})}}>
                    <div className="cell small-2 text-right">
                      <i className={`ic-check fal ${filters.departments.selected[name] ? 'fa-check-square' : 'fa-square'}`}></i>
                    </div>
                    <div className="cell small-8">
                      {name}
                    </div>
                    <div className="cell small-2">
                      ({count})
                    </div>
                  </div>
              )
              list.push(itemHtml)
            }
          }
        }
      }
    }

    let html = (
      <div>
        <div className="filter-title">
          Category
        </div>
        <div className="search-sel-wrapper">
          <div className="input-list-wrapper" onClick={self.handleInputClicked}>
            <input className="input-list" type="text" placeholder="Category"
              style={{borderRadius: 0}}
              value={filters.departments.query} onChange={self.handleInputChanged} />
            <i className="ico-search fal fa-search"></i>
            <i className={`ico-down fal fa-chevron-${filters.departments.on ? 'up' : 'down'}`}></i>
          </div>
          <div className={`${filters.departments.on ? 'shown' : 'hidden'}`}>
            <div className="indent-list">
              {list}
            </div>
            <div className="list-action text-center hidden">
              Show more departments
            </div>
          </div>
        </div>
      </div>
    )
    return html
  }
}

export default Page
